/* ============================================================
   ATELIER HOMEPAGE SECTIONS - shared behaviour, ported from
   _bsd-home-v5-atelier-harness.html. Self-contained; loaded
   (deferred, deduped by URL) by every atelier-* home section.
   - [data-at-rv] staggered reveal-on-scroll
   - about-chapter tabs
   - FAQ accordion (one open at a time)
   - testimonial rail pointer-drag
   ============================================================ */
(function () {
  'use strict';
  if (window.__atHomeInit) return; /* sections all load this file once */
  window.__atHomeInit = true;

  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function init() {
    initNewestFirst();

    /* reveal on scroll */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('at-rv-in');
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px 60px 0px' });
      /* fires slightly below the fold so the settle is already underway as
         content enters - visible as a soft settle, never a performance
         (de-AI pass, Chris 2026-07-20; tuned to the middle same day) */
      $$('[data-at-rv]').forEach(function (el) { io.observe(el); });
    } else {
      $$('[data-at-rv]').forEach(function (el) { el.classList.add('at-rv-in'); });
    }

    /* ---------- finish strip preview (desktop hover FAN / mobile hold BLOOM) ----------
       Data: #atFinPrevData = per-finish [{i,t,p,u} x3], the finish's most-ordered
       products (liquid-resolved live). Desktop: settle-debounced hover shows a 3-card
       specimen fan above the swatch. Touch: LONG-PRESS blooms the 3 cards around the
       finger; drag highlights one (caption shows title+price); release ON a card
       commits to a centred card + View product; release off glides everything home.
       Plain tap still navigates (hold = accelerator, never the only path).
       Mechanics per the finish-bloom groundwork: arm timer + move-cancel, scroll
       locked only AFTER arm, post-hold click suppressed, CSS transitions only
       (WAAPI double-renders on iOS), nearest-slot hit-test (thumb occludes). */
    (function () {
      var row = document.querySelector('.at-fin-row');
      var dataEl = document.getElementById('atFinPrevData');
      if (!row || !dataEl) return;
      var DATA = {};
      try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var items = $$('.at-fin-it', row).filter(function (a) {
        var d = DATA[a.getAttribute('data-fp-key')];
        return d && d.length;
      });
      if (!items.length) return;
      function prods(it) { return DATA[it.getAttribute('data-fp-key')]; }

      /* ============ desktop hover fan ============
         v2 (2026-07-20, Chris): the fan is no longer just a visual. Hovering
         UP into it spreads the three cards side-by-side with title + price
         (+ a Popular chip on the top pick - the picks ARE popularity-ranked,
         see the section's fin_data notes), each card is a real link to its
         PDP, and cards float with the cursor (transform-only tilt, skipped
         under reduced-motion). A grace timer covers the cursor's travel
         between swatch and fan. Mobile parity = the hold bloom below. */
      if (window.matchMedia('(hover: hover)').matches) {
        var noTilt = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var fan = document.createElement('div');
        fan.className = 'at-fpfan';
        for (var i = 0; i < 3; i++) {
          var fig = document.createElement('a');
          fig.className = 'at-fpc';
          var im = document.createElement('img');
          im.alt = '';
          fig.appendChild(im);
          var meta = document.createElement('span');
          meta.className = 'at-fpc-m';
          meta.innerHTML = '<b></b><i></i>';
          fig.appendChild(meta);
          /* all three ARE the finish's top sellers by real order data
             (fin_data notes) - every card earns the chip */
          var pop = document.createElement('em');
          pop.className = 'at-fpc-pop';
          pop.textContent = 'Popular';
          fig.appendChild(pop);
          fan.appendChild(fig);
        }
        document.body.appendChild(fan);
        var fanCards = $$('.at-fpc', fan);
        var GAP = 12, EDGE = 10, fanKey = '', showT, hideT, curIt = null;
        /* lifecycle is driven by COORDINATES, not enter/leave events: when
           the fan appears 130ms after hover, a fast cursor is already parked
           where the cards materialize - and Chrome does not reliably fire
           mouseenter for an element appearing under a stationary pointer,
           so the swatch's armed hide won the race and faded the fan out
           from under the cursor (the v3 bug). lastX/lastY + the fan's known
           box make every decision race-free. */
        var lastX = -1, lastY = -1, fanBox = null;

        /* geometry CONSTANTS, not measurements: mid-transition offsetWidth
           reads the in-flight size and mis-centers the fan (the v2 bug).
           Keep in sync with the CSS: stacked 3x96 - 2x14 overlap = 260 wide,
           96-wide 4/5 cards = 120 tall; spread 3x122 + 2x10 = 386 wide,
           122-wide 4/5 cards = 153 tall. */
        function fanPlace(spread) {
          if (!curIt) return;
          var r = curIt.getBoundingClientRect();
          var w = spread ? 386 : 260, h = spread ? 153 : 120;
          var x = Math.max(EDGE, Math.min(r.left + r.width / 2 - w / 2, window.innerWidth - w - EDGE));
          var y = r.top - h - GAP - 8;
          if (y < EDGE) y = r.bottom + GAP;
          fan.style.setProperty('--px', Math.round(x) + 'px');
          fan.style.setProperty('--py', Math.round(y) + 'px');
          fanBox = { x: x, y: y, w: w, h: h };
        }
        function overItem(x, y) {
          if (!curIt) return false;
          var r = curIt.getBoundingClientRect();
          return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
        }
        function inKeep(x, y) {
          /* the keep zone = fan box inflated enough (26px) to swallow the
             20px corridor down to the swatch, OR the swatch itself */
          if (fanBox) {
            var p = 26;
            if (x >= fanBox.x - p && x <= fanBox.x + fanBox.w + p &&
                y >= fanBox.y - p && y <= fanBox.y + fanBox.h + p) return true;
          }
          return overItem(x, y);
        }
        function spreadNow() {
          if (fan.classList.contains('spread')) return;
          /* the deal entrance holds its final transform (fill:both) and
             would pin the cards mid-glide - release it before spreading */
          fan.classList.remove('deal');
          fan.classList.add('spread');
          fanPlace(true);
        }
        function unspreadNow() {
          if (!fan.classList.contains('spread')) return;
          fan.classList.remove('spread');
          fanPlace(false);
        }
        function fanShow(it) {
          curIt = it;
          /* hovering the swatch = stacked state; the spread belongs to the
             fan itself (cards glide back if the cursor returns to the row) */
          fan.classList.remove('spread');
          var key = it.getAttribute('data-fp-key');
          var list = prods(it);
          if (key !== fanKey) {
            fanKey = key;
            fanCards.forEach(function (c, i) {
              var im = c.querySelector('img');
              if (list[i]) {
                c.hidden = false;
                if (list[i].u) c.href = list[i].u; else c.removeAttribute('href');
                c.querySelector('.at-fpc-m b').textContent = list[i].t || '';
                c.querySelector('.at-fpc-m i').textContent = list[i].p || '';
                im.style.opacity = '0';
                im.onload = function () { im.style.opacity = ''; };
                im.src = list[i].i;
                if (im.complete) im.style.opacity = '';
              } else { c.hidden = true; im.removeAttribute('src'); c.removeAttribute('href'); }
            });
            fan.classList.remove('deal');
            void fan.offsetWidth;
            fan.classList.add('deal');
          }
          fanPlace(false);
          fan.classList.add('on');
          /* a fast cursor may already be parked inside the fan's box when it
             appears - spread immediately, no boundary event needed */
          if (lastX >= 0 && !overItem(lastX, lastY) && inKeep(lastX, lastY)) spreadNow();
        }
        function fanHide(force) {
          /* timers can fire late; never hide while the pointer verifiably
             sits in the keep zone (scroll/doc-exit pass force=true) */
          if (!force && fan.classList.contains('on') && lastX >= 0 && inKeep(lastX, lastY)) return;
          fan.classList.remove('on', 'spread');
          fanCards.forEach(function (c) { c.style.setProperty('--rx', '0deg'); c.style.setProperty('--ry', '0deg'); });
        }
        items.forEach(function (it) {
          it.addEventListener('mouseenter', function () {
            clearTimeout(showT); clearTimeout(hideT);
            showT = setTimeout(function () { fanShow(it); }, 130);
          });
          it.addEventListener('mouseleave', function (e) {
            clearTimeout(showT); clearTimeout(hideT);
            if (!inKeep(e.clientX, e.clientY)) hideT = setTimeout(fanHide, 220);
          });
        });
        /* the coordinate KEEPER: while the fan is up, every pointer move
           decides keep-alive / spread / collapse / hide from geometry */
        document.addEventListener('pointermove', function (e) {
          lastX = e.clientX; lastY = e.clientY;
          if (!fan.classList.contains('on')) return;
          if (inKeep(lastX, lastY)) {
            clearTimeout(hideT);
            if (overItem(lastX, lastY)) { unspreadNow(); }
            else if (curIt) {
              /* spread only once the pointer has genuinely LEFT the swatch
                 band toward the cards - sliding sideways along the row must
                 not pop a neighbour's fan open */
              var ir = curIt.getBoundingClientRect();
              if (lastY < ir.top || lastY > ir.bottom) spreadNow();
            }
          } else {
            clearTimeout(hideT);
            hideT = setTimeout(fanHide, 120);
          }
        }, { passive: true });
        document.addEventListener('mouseleave', function () { fanHide(true); });
        if (!noTilt) {
          fan.addEventListener('pointermove', function (e) {
            if (!fan.classList.contains('spread')) return;
            var c = e.target.closest && e.target.closest('.at-fpc');
            if (!c || !fan.contains(c)) return;
            var r = c.getBoundingClientRect();
            var px = (e.clientX - r.left) / r.width - 0.5;
            var py = (e.clientY - r.top) / r.height - 0.5;
            c.style.setProperty('--ry', (px * 10).toFixed(2) + 'deg');
            c.style.setProperty('--rx', (-py * 8).toFixed(2) + 'deg');
          });
          fan.addEventListener('pointerout', function (e) {
            var c = e.target.closest && e.target.closest('.at-fpc');
            if (c) { c.style.setProperty('--ry', '0deg'); c.style.setProperty('--rx', '0deg'); }
          });
        }
        window.addEventListener('scroll', function () { fanHide(true); }, { passive: true });
      }

      /* ============ mobile hold bloom ============ */
      var ov = null, ovCards = [], cap = null, tray = null, view = null, xBtn = null;
      var sel = -1, committed = false, ignoreUntil = 0, curList = null, holdIt = null;
      var CW = 104, CH = 130; /* card box */

      function buildOv() {
        if (ov) return;
        ov = document.createElement('div');
        ov.className = 'at-fpov';
        /* <i> filler: the store globally hides empty styled divs (div:empty) */
        ov.innerHTML =
          '<div class="at-fpov-scrim"><i></i></div>' +
          '<figure class="at-fpc"><img alt=""></figure>' +
          '<figure class="at-fpc"><img alt=""></figure>' +
          '<figure class="at-fpc"><img alt=""></figure>' +
          '<div class="at-fp-cap"><b></b><span></span></div>' +
          '<div class="at-fp-tray"><b class="at-fp-t"></b><span class="at-fp-p"></span><br><a class="at-fp-view" href="#">View product</a></div>' +
          '<button class="at-fp-x" type="button" aria-label="Close">&#10005;</button>';
        document.body.appendChild(ov);
        ovCards = $$('.at-fpc', ov);
        cap = ov.querySelector('.at-fp-cap');
        tray = ov.querySelector('.at-fp-tray');
        view = ov.querySelector('.at-fp-view');
        xBtn = ov.querySelector('.at-fp-x');
        ov.querySelector('.at-fpov-scrim').addEventListener('click', function () {
          if (committed && Date.now() > ignoreUntil) teardown();
        });
        xBtn.addEventListener('click', function () { if (Date.now() > ignoreUntil) teardown(); });
        view.addEventListener('click', function (e) {
          if (Date.now() < ignoreUntil) e.preventDefault();
        });
        /* committed overlay owns the touch - keep the page still behind it */
        ov.addEventListener('touchmove', function (e) {
          if (committed) e.preventDefault();
        }, { passive: false });
      }

      var slots = [];
      function bloom(it, tx, ty) {
        buildOv();
        curList = prods(it);
        var r = it.getBoundingClientRect();
        var sx = r.left + r.width / 2 - CW / 2, sy = r.top - CH / 2;
        var vw = window.innerWidth;
        /* ---- ARC geometry (the finish-bloom model) ----
           Cards sit on a ring of radius R around the finger, 55deg apart - the
           chord between neighbours (2R sin 27.5 ~ 137px) clears the 104px cards,
           so they NEVER overlap. Near a L/R edge the WHOLE arc rotates toward
           the open side just enough to keep the binding card inside the margin
           (the bloom's edge-tilt), instead of clamping cards onto each other. */
        var R = 148, HALF = 55 * Math.PI / 180, PAD = 8;
        var up = ty - (R + CH / 2 + 44) > 56; /* headroom for arc + caption? else fan below */
        var angs = [-HALF, 0, HALF];
        var rot = 0;
        var q = (PAD + CW / 2 - tx) / R;              /* left bind: sin(a+rot) >= q  */
        if (Math.sin(angs[0]) < q) rot = Math.asin(Math.min(1, q)) - angs[0];
        var p = (vw - PAD - CW / 2 - tx) / R;         /* right bind: sin(a+rot) <= p */
        if (Math.sin(angs[2] + rot) > p) rot = Math.asin(Math.max(-1, p)) - angs[2];
        slots = angs.map(function (a) {
          var ang = a + rot;
          var cx = tx + R * Math.sin(ang);
          var cy = up ? ty - R * Math.cos(ang) : ty + R * Math.cos(ang);
          return {
            cx: Math.max(PAD + CW / 2, Math.min(cx, vw - PAD - CW / 2)), /* backstop only */
            cy: Math.max(PAD + CH / 2, cy),
            r: Math.round(ang * 180 / Math.PI * 0.3)
          };
        });
        ovCards.forEach(function (c, i) {
          var im = c.querySelector('img');
          if (curList[i]) {
            c.hidden = false;
            im.src = curList[i].i;
            c.style.setProperty('--sx', Math.round(sx) + 'px');
            c.style.setProperty('--sy', Math.round(sy) + 'px');
            c.style.setProperty('--x', Math.round(slots[i].cx - CW / 2) + 'px');
            c.style.setProperty('--y', Math.round(slots[i].cy - CH / 2) + 'px');
            c.style.setProperty('--r', slots[i].r + 'deg');
            c.classList.remove('sel', 'big', 'out');
          } else { c.hidden = true; }
        });
        var topmost = Math.min(slots[0].cy, slots[1].cy, slots[2].cy) - CH / 2;
        var lowest = Math.max(slots[0].cy, slots[1].cy, slots[2].cy) + CH / 2;
        cap.style.setProperty('--capy', Math.max(10, up ? topmost - 42 : lowest + 14) + 'px');
        sel = -1; committed = false;
        ov.classList.remove('commit');
        void ov.offsetWidth;
        ov.classList.add('show');
      }
      function track(tx, ty) {
        if (committed || !ov) return;
        var bi = -1, bd = 1e9;
        slots.forEach(function (s, i) {
          if (!curList[i]) return;
          var dx = tx - s.cx, dy = ty - s.cy;
          var d = dx * dx + dy * dy;
          if (d < bd) { bd = d; bi = i; }
        });
        if (bd > 120 * 120) bi = -1; /* too far from every card */
        if (bi !== sel) {
          sel = bi;
          ovCards.forEach(function (c, i) { c.classList.toggle('sel', i === sel); });
          if (sel >= 0) {
            cap.querySelector('b').textContent = curList[sel].t;
            cap.querySelector('span').textContent = curList[sel].p;
            cap.classList.add('on');
          } else cap.classList.remove('on');
        }
      }
      function commit() {
        committed = true;
        ignoreUntil = Date.now() + 380; /* swallow the synthetic release-click */
        var vw = window.innerWidth, vh = window.innerHeight;
        var big = ovCards[sel];
        var bh = CH * 1.9;
        var by = Math.max(70, vh * 0.16);
        /* scale() expands around the card's centre: place by pre-scale top-left */
        big.style.setProperty('--bx', Math.round((vw - CW) / 2) + 'px');
        big.style.setProperty('--by', Math.round(by + (bh - CH) / 2) + 'px');
        ovCards.forEach(function (c, i) {
          c.classList.toggle('big', i === sel);
          c.classList.toggle('out', i !== sel);
          c.classList.remove('sel');
        });
        cap.classList.remove('on');
        tray.querySelector('.at-fp-t').textContent = curList[sel].t;
        tray.querySelector('.at-fp-p').textContent = curList[sel].p;
        view.setAttribute('href', curList[sel].u);
        tray.style.setProperty('--trayy', Math.round(by + bh + 26) + 'px');
        ov.classList.add('commit');
      }
      function teardown() {
        if (!ov) return;
        committed = false;
        ov.classList.remove('show', 'commit');
        cap.classList.remove('on');
        if (holdIt) { holdIt.classList.remove('is-held'); holdIt = null; }
      }

      var HOLD_MS = 380, SLOP = 10;
      items.forEach(function (it) {
        var t = null, sx = 0, sy = 0, held = false;
        function disarm() { if (t) { clearTimeout(t); t = null; } }
        it.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1 || committed) return;
          held = false;
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
          disarm();
          t = setTimeout(function () {
            t = null;
            held = true;
            holdIt = it;
            it.classList.add('is-held');
            bloom(it, sx, sy);
          }, HOLD_MS);
        }, { passive: true });
        it.addEventListener('touchmove', function (e) {
          if (held) {
            e.preventDefault(); /* previewing: the page stays still */
            track(e.touches[0].clientX, e.touches[0].clientY);
            return;
          }
          if (!t) return;
          var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
          if (dx * dx + dy * dy > SLOP * SLOP) disarm(); /* scroll intent - stand down */
        }, { passive: false });
        function end() {
          disarm();
          if (!held) return;
          it.classList.remove('is-held');
          if (sel >= 0) commit();
          else teardown();
        }
        it.addEventListener('touchend', end);
        it.addEventListener('touchcancel', function () { disarm(); if (held) teardown(); });
        /* a hold must not also navigate; a plain tap still does */
        it.addEventListener('click', function (e) {
          if (held) { e.preventDefault(); e.stopPropagation(); held = false; }
        }, true);
      });

      /* idle-preload every preview thumb so the first hover/hold is instant */
      setTimeout(function () {
        Object.keys(DATA).forEach(function (k) {
          (DATA[k] || []).forEach(function (p) { new Image().src = p.i; });
        });
      }, 2000);
    })();

    /* about chapters */
    $$('.at-about').forEach(function (root) {
      var tabs = $$('.at-abt', root), panes = $$('.at-ab-pane', root);
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.toggle('on', x === t); });
          panes.forEach(function (p, j) { p.classList.toggle('on', j === i); });
        });
      });
    });

    /* FAQ accordion */
    $$('.at-faq-main').forEach(function (fm) {
      fm.addEventListener('click', function (e) {
        var q = e.target.closest('.at-acc-q');
        if (!q) return;
        var acc = q.parentNode, was = acc.classList.contains('on');
        $$('.at-acc.on', fm).forEach(function (a) { a.classList.remove('on'); });
        if (!was) acc.classList.add('on');
      });
    });

    /* drag-scroll rails (testimonials + product carousel) */
    $$('.at-tst-rail, .at-p-rail').forEach(function (r) {
      var down = false, sx = 0, sl = 0, moved = 0, pid = null;
      r.addEventListener('pointerdown', function (e) {
        /* Touch and pen use native scrolling: do not capture a vertical swipe. */
        moved = 0;
        if (e.pointerType !== 'mouse' || e.button !== 0) { down = false; return; }
        down = true; moved = 0; sx = e.clientX; sl = r.scrollLeft; pid = e.pointerId;
        /* do NOT capture here: capturing on the bare press retargets the
           eventual click to the rail (Chrome), so card links never fire.
           Capture only once movement proves it's a drag (below). */
      });
      r.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        moved = Math.max(moved, Math.abs(dx));
        if (moved > 6) {
          if (pid !== null) { try { r.setPointerCapture(pid); } catch (err) {} pid = null; }
          r.classList.add('dragging'); r.scrollLeft = sl - dx;
        }
      });
      function up() {
        down = false;
        requestAnimationFrame(function () { r.classList.remove('dragging'); });
      }
      r.addEventListener('pointerup', up);
      r.addEventListener('pointercancel', up);
      /* suppress link clicks while dragging */
      r.addEventListener('click', function (e) { if (moved > 6) e.preventDefault(); }, true);
    });

    /* infinite wrap (Chris 2026-07-20): replaces the end-of-list "big scroll
       back to the start". The first 4 cards are CLONED onto the tail; the
       moment the scroll enters the clone zone we teleport back exactly one
       loop-width with snap + smoothness momentarily off - the frame is
       visually identical, so autoplay, arrows and drags all just keep going.
       Clones are aria-hidden with unfocusable controls (the originals stay
       the canonical copies; card JS is delegated so clones stay live).
       Teleports are skipped mid-drag - the drag handler owns scrollLeft. */
    $$('[data-at-rail]').forEach(function (track) {
      var cards = $$('.at-rail-card', track);
      if (cards.length < 5) return;
      var clones = cards.slice(0, 4).map(function (c) {
        var k = c.cloneNode(true);
        k.setAttribute('aria-hidden', 'true');
        k.removeAttribute('data-shopify-editor-block');
        $$('a,button,input,select,textarea', k).forEach(function (el) { el.tabIndex = -1; });
        track.appendChild(k);
        return k;
      });
      var loopW = 0;
      /* rect-based (fractional) measurement - offsetLeft rounds to ints and
         at 125%-style display scales the rounded loop width can sit ABOVE
         every reachable scrollLeft, so the seam check never fires */
      function measure() { loopW = clones[0].getBoundingClientRect().left - cards[0].getBoundingClientRect().left; }
      measure();
      window.addEventListener('resize', measure);
      track.dataset.atWrapped = '1';
      /* 2px tolerance: a smooth scroll + snap can settle a fraction short of
         the exact seam; teleporting a couple of px early is invisible. Also
         exposed on the element so autoplay can self-heal a rail that parked
         at the clamped end without emitting further scroll events. */
      function norm() {
        if (!loopW || track.classList.contains('dragging')) return;
        if (track.scrollLeft >= loopW - 2) {
          var sl = Math.max(0, track.scrollLeft - loopW);
          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = sl;
          track.style.scrollSnapType = '';
          track.style.scrollBehavior = '';
        }
      }
      track.addEventListener('scroll', norm, { passive: true });
      track._atWrapNorm = norm;
    });

    /* product carousel: one card step = card width + the track's gap */
    function railStep(track) {
      var card = track.querySelector('.at-rail-card');
      if (!card) return 0;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    /* carousel arrows (delegated; advance two cards, like the range rail) */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-at-rail-arr]');
      if (!btn) return;
      var sect = btn.closest('.at-prods');
      var track = sect && sect.querySelector('[data-at-rail]');
      if (!track) return;
      var dir = parseInt(btn.getAttribute('data-at-rail-arr'), 10) || 1;
      track.scrollBy({ left: dir * railStep(track) * 2, behavior: 'smooth' });
    });

    /* carousel autoplay: advance one card every 5s, loop back at the end.
       Pauses on hover/focus and after a touch; skipped under reduced-motion. */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion) {
      $$('[data-at-rail][data-at-autoplay]').forEach(function (track) {
        var paused = false;
        function advance() {
          if (paused || !track.isConnected) return;
          if (track.scrollWidth <= track.clientWidth + 4) return; /* nothing to scroll */
          if (track._atWrapNorm) track._atWrapNorm(); /* un-park a rail frozen at the seam */
          if (!track.dataset.atWrapped && track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) {
            /* short unwrapped rails still rewind; wrapped rails just keep
               stepping - the clone-zone teleport closes the loop */
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: railStep(track), behavior: 'smooth' });
          }
        }
        setInterval(advance, 5000);
        track.addEventListener('mouseenter', function () { paused = true; });
        track.addEventListener('mouseleave', function () { paused = false; });
        track.addEventListener('focusin', function () { paused = true; });
        track.addEventListener('focusout', function () { paused = false; });
        track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      });
    }
  }

  /* ---------- newest-first product grid (survives the sort_order sweeper) ----------
     A third-party collection merchandiser rewrites every collection's sort_order back to
     `manual` on a schedule, so "first N of the collection" stops meaning "newest" within
     hours. The storefront sort_by URL parameter overrides the stored order, so we re-ask
     for the cards in created-descending order per page view.

     Progressive enhancement: the server-rendered cards are already on the page and stay
     put if fetch is unavailable, the request fails, or the response is not our endpoint.
     Only wrapper CONTENTS are replaced, so the grid wrapper classes and the delegated card
     handlers bound on .atelier-collection are untouched. Grid only - the carousel clones
     its own cards to close its scroll loop, and a swap would corrupt that list.

     THREE GUARDS, each earning its place:
     1. #at-newrail sentinel. A MISSING template does not 404 - Shopify silently serves the
        full collection page (200 OK, ~769KB, header and footer). That page has .pc cards in
        it, so scraping .pc blind would "work" while dragging 769KB onto the landing page.
     2. A streaming byte cap. MEASURED: Shopify serves these chunked with NO Content-Length
        header at all, so a header pre-check would never once have fired - we read the body
        through a reader and cancel past 150KB instead. The real endpoint is ~47KB, the
        full-page fallback ~769KB, so the cap separates them cleanly.
     3. sessionStorage circuit breaker, so a theme missing the template costs ONE bad
        response per session rather than one per page view.

     The 2500px rootMargin is load-bearing: card images are loading="lazy", so the swap must
     land before the browser's own ~1250px threshold starts pulling the stale cards' images.
     Firing later downloads two sets of images and shifts layout in view.  */
  function initNewestFirst(scope) {
    var grids = $$('[data-at-newest]', scope);
    if (!grids.length) return;

    /* Never leave the pending hold on: the cards are opacity:0 until this runs. */
    function reveal(grid) { grid.classList.remove('at-p-grid--pending'); }

    var BROKEN = 'at-newrail-broken';
    var isBroken = false;
    try { isBroken = sessionStorage.getItem(BROKEN) === '1'; } catch (e) {}
    if (!window.fetch || !window.DOMParser || isBroken) { grids.forEach(reveal); return; }

    function markBroken() { try { sessionStorage.setItem(BROKEN, '1'); } catch (e) {} }

    /* Read at most `cap` bytes, then cancel. Guards against the full-page fallback on a
       theme without the template: Shopify sends these chunked with no Content-Length, so
       the only way to bound the transfer is to watch it arrive. Browsers without a body
       reader fall back to text() - the sentinel check still rejects the wrong document,
       they just pay for it once before the circuit breaker trips. */
    function readCapped(r, cap) {
      if (!r.body || !r.body.getReader || !window.TextDecoder) return r.text();
      var reader = r.body.getReader(), chunks = [], total = 0;
      return new Promise(function (resolve, reject) {
        (function pump() {
          reader.read().then(function (res) {
            if (res.done) {
              var buf = new Uint8Array(total), at = 0;
              chunks.forEach(function (c) { buf.set(c, at); at += c.length; });
              resolve(new TextDecoder('utf-8').decode(buf));
              return;
            }
            total += res.value.length;
            if (total > cap) {
              reader.cancel();
              markBroken();
              reject('oversized');
              return;
            }
            chunks.push(res.value);
            pump();
          }).catch(reject);
        })();
      });
    }

    function swap(grid) {
      if (grid.hasAttribute('data-at-newest-loaded') || grid.hasAttribute('data-at-newest-busy')) return;
      var handle = grid.getAttribute('data-at-newest');
      var slots = Array.prototype.slice.call(grid.children);
      if (!handle || !slots.length) { reveal(grid); return; }
      grid.setAttribute('data-at-newest-busy', '');

      /* priority:'low' is a hint - browsers that do not know it ignore the key.
         No AbortController: readCapped's reader.cancel() already stops the transfer. */
      fetch('/collections/' + encodeURIComponent(handle) + '?view=newrail&sort_by=created-descending',
            { credentials: 'same-origin', priority: 'low' })
        .then(function (r) {
          if (!r.ok) return Promise.reject('http ' + r.status);
          return readCapped(r, 150000);
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var box = doc.getElementById('at-newrail');
          if (!box) { markBroken(); return Promise.reject('not our endpoint'); }
          var cards = box.querySelectorAll('.pc');
          if (!cards.length) return Promise.reject('empty');
          slots.forEach(function (slot, i) {
            if (cards[i]) slot.innerHTML = cards[i].outerHTML;
            else slot.remove();          /* fewer products than we have slots */
          });
          grid.setAttribute('data-at-newest-loaded', '');
        })
        .catch(function () { /* every failure path keeps the server-rendered cards */ })
        .then(function () {
          grid.removeAttribute('data-at-newest-busy');
          reveal(grid);
        });
    }

    if ('IntersectionObserver' in window) {
      var nio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          nio.unobserve(en.target);
          swap(en.target);
        });
      }, { rootMargin: '2500px 0px' });
      grids.forEach(function (g) { nio.observe(g); });
    } else {
      grids.forEach(swap);
    }
  }

  /* Theme editor: a re-rendered section arrives with fresh, un-swapped markup. */
  document.addEventListener('shopify:section:load', function (e) { initNewestFirst(e.target); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

